import React, { useState } from "react";
import "./AstroTipsSection.css";

const tips = [
  {
    id: 1,
    thumbnail: "https://images.unsplash.com/photo-1518183214770-9cffbec72538?w=600&q=80",
    duration: "12:45",
    title: "How to Attract Wealth & Prosperity",
    author: "By Acharya Karan",
    tag: "Finance",
  },
  {
    id: 2,
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&q=80",
    duration: "08:20",
    title: "Daily Morning Routine for Success",
    author: "By Dr. Sunita",
    tag: "Lifestyle",
  },
  {
    id: 3,
    thumbnail: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80",
    duration: "15:10",
    title: "Vastu Tips for Your Main Entrance",
    author: "By Pandit Ji",
    tag: "Vastu",
  },
  {
    id: 4,
    thumbnail: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=600&q=80",
    duration: "10:38",
    title: "Meditation for Inner Peace & Clarity",
    author: "By Astrologer Asha",
    tag: "Wellness",
  },
];

const AstroTipsSection = () => {
  const [hoveredId, setHoveredId] = useState(null);

  return (
    <section className="at-section">
      {/* Header */}
      <div className="at-header">
        <div className="at-eyebrow">
          <span className="at-eyebrow-line"></span>
          <span className="at-eyebrow-text">EXPERT GUIDANCE</span>
          <span className="at-eyebrow-line"></span>
        </div>
        <h2 className="at-title">
          FREE ASTROLOGY TIPS<br />& VIDEOS
        </h2>
      </div>

      {/* Grid */}
      <div className="at-grid">
        {tips.map((tip) => (
          <div
            className={`at-card ${hoveredId === tip.id ? "at-card-hovered" : ""}`}
            key={tip.id}
            onMouseEnter={() => setHoveredId(tip.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            {/* Thumbnail */}
            <div className="at-thumb-wrap">
              <img
                src={tip.thumbnail}
                alt={tip.title}
                className="at-thumb"
                loading="lazy"
              />
              {/* Overlay */}
              <div className="at-overlay"></div>

              {/* Tag */}
              <span className="at-tag">{tip.tag}</span>

              {/* Play button */}
              <div className="at-play-btn">
                <svg viewBox="0 0 24 24" fill="white" width="22" height="22">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>

              {/* Duration */}
              <span className="at-duration">{tip.duration}</span>
            </div>

            {/* Info */}
            {/* <div className="at-info">
              <h3 className="at-card-title">{tip.title}</h3>
              <p className="at-author">{tip.author}</p>
            </div> */}
          </div>
          
        ))}
        </div>
     
      {/* YouTube Button */}
    <div className="at-yt-wrap">
  <a
    href="https://www.youtube.com/@AstroBhagya_Official"
    target="_blank"
    rel="noopener noreferrer"
    className="at-yt-btn"
  >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
          </svg>
          Watch More on YouTube
        </a>
      </div>
    </section>
  );
};

export default AstroTipsSection;